<template>
  <div class="tabs-wrapper">
    <div class="tab-buttons">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{ active: currentTab === index }"
        @click="currentTab = index"
      >
        {{ tab.name }}
      </button>
    </div>

    <div class="tab-content">
      <component :is="tabs[currentTab].component" />
    </div>
  </div>
</template>

<script>
import ApiInvoiceDoc from "./InvoiceDoc.vue";
import InvoiceForm from "./InvoiceApi.vue";

export default {
  name: "InvoiceApiTabs",
  components: {
    ApiInvoiceDoc,
    InvoiceForm
  },
  data() {
    return {
      currentTab: 0,
      tabs: [
        { name: "📝 Formulario", component: "InvoiceForm" },
        { name: "📄 Documentación", component: "ApiInvoiceDoc" }
      ]
    };
  }
};
</script>

<style scoped>
.tabs-wrapper {
  max-width: 1000px;
  margin: auto;
  font-family: sans-serif;
}
.tab-buttons {
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 1rem;
}
.tab-buttons button {
  flex: 1;
  padding: 10px 15px;
  cursor: pointer;
  border: none;
  background: #f9f9f9;
  font-weight: bold;
  transition: background 0.3s;
}
.tab-buttons button.active {
  background: #fff;
  border-bottom: 2px solid #3edbbf;
  color: #3edbbf;
}
.tab-content {
  background: #fff;
  padding: 20px;
  border: 1px solid #ddd;
}
</style>
